import {get, isEmpty} from 'lodash'

export const ContactEmailType = {
  QUOTE_ACCEPTANCE: 'quote-accept',
  QUOTE_ATTACHMENT: 'quote-attachment',
  INVOICE_ATTACHMENT: 'invoice-attachment',
  PRODUCTION_START: 'production-start',
  PRODUCTION_COMPLETE: 'production-complete',
  ORDER_READY_FOR_COLLECTION: 'ready-for-collection',
  ORDER_DISPATCHED: 'order-dispatched',
  DELIVERY_NOTE_TEMPLATE: 'delivery-note-attachment',
  PURCHASE_ORDER_TEMPLATE: 'purchase-order-attachment',
  PURCHASE_ORDER_ACCEPTANCE: 'purchase-order-accept',
}

export const getFormDataFor = (emailDetails, contactEmailType) => {

  const toContacts = get(emailDetails, 'toContacts', [])
  const toEmails = get(emailDetails, 'toEmails', [])
  const ccEmails = get(emailDetails, 'ccEmails', [])
  const bccEmails = get(emailDetails, 'bccEmails', [])
  const printTemplateId = get(emailDetails, 'printTemplateId', null)

  const formData = new FormData()

  formData.append("id", get(emailDetails, 'id', null))
  if (printTemplateId) formData.append("printTemplateId", printTemplateId)
  if (contactEmailType) formData.append("contactEmailType", contactEmailType)
  formData.append("contactIds", toContacts.join(';'))
  formData.append("toEmails", toEmails.join(';'))
  formData.append("ccEmails", ccEmails.join(';'))
  formData.append("bccEmails", bccEmails.join(';'))
  formData.append("fromEmail", get(emailDetails, 'from', null))
  formData.append("fromName", get(emailDetails, 'fromName', null))
  formData.append("replyToEmail", get(emailDetails, 'reply', null))
  formData.append("replyName", get(emailDetails, 'replyName', null))
  formData.append("subject", get(emailDetails, 'subject', null))
  formData.append("body", get(emailDetails, 'body', null))

  const emailAttachments = get(emailDetails, 'emailAttachments', [])
  if (!isEmpty(emailAttachments)) {
    for (let j = 0; j < emailAttachments.length; j++) {
      const file = emailAttachments[j]
      const fileName = file.name
      formData.append('emailAttachment', file, fileName)
    }
  }

  const isSendCopyEnabled = get(emailDetails, 'isSendCopyEnabled', false)
  formData.append("isSendCopyEnabled", isSendCopyEnabled.toString())
  return formData
}
